import pieceImages from "pieces/*.png";

//800x800
let data = [
  {
    name: "H1_Julistepeli_1",
    data: [
      { x: 404, y: 697 },
      { x: 412, y: 674 },
      { x: 418, y: 679 },
      { x: 486, y: 630 },
      { x: 488, y: 621 },
      { x: 407, y: 577 },
      { x: 356, y: 556 },
      { x: 311, y: 547 },
      { x: 306, y: 549 },
      { x: 363, y: 692 },
      { x: 404, y: 696 },
    ],
    initialValues: { 
    left: "-12.1%",
    top: "-67.66%"
    },
  },
  {
    name: "H1_Julistepeli_2",
    data: [
      { x: 592, y: 278 },
      { x: 584, y: 183 },
      { x: 594, y: 101 },
      { x: 487, y: 104 },
      { x: 480, y: 104 },
      { x: 432, y: 147 },
      { x: 417, y: 172 },
      { x: 443, y: 226 },
      { x: 467, y: 286 },
      { x: 490, y: 355 },
      { x: 527, y: 337 },
      { x: 546, y: 312 },
      { x: 565, y: 301 },
      { x: 590, y: 273 },
    ],
    initialValues: {
      left: "-51.66%",
      top: "24.8%",
    },
  },
  {
    name: "H1_Julistepeli_3",
    data: [
      { x: 516, y: 605 },
      { x: 489, y: 626 },
      { x: 395, y: 577 },
      { x: 317, y: 549 },
      { x: 308, y: 549 },
      { x: 289, y: 525 },
      { x: 313, y: 499 },
      { x: 326, y: 473 },
      { x: 446, y: 389 },
      { x: 453, y: 383 },
      { x: 459, y: 378 },
      { x: 475, y: 370 },
      { x: 488, y: 351 },
      { x: 496, y: 381 },
      { x: 503, y: 400 },
      { x: 502, y: 419 },
      { x: 520, y: 520 },
      { x: 510, y: 555 },
      { x: 514, y: 604 },
    ],
    initialValues: { 
    left: "34.5%",
    top: "32.5%"

     },
  },
  {
    name: "H1_Julistepeli_4",
    data: [
      { x: 492, y: 355 },
      { x: 452, y: 382 },
      { x: 381, y: 273 },
      { x: 359, y: 240 },
      { x: 359, y: 230 },
      { x: 373, y: 205 },
      { x: 413, y: 167 },
      { x: 426, y: 183 },
      { x: 449, y: 238 },
      { x: 468, y: 283 },
      { x: 485, y: 326 },
      { x: 492, y: 354 },
    ],
    initialValues: {

    left: "4.3%",
    top: "54.66%"

    },
  },
  {
    name: "H1_Julistepeli_5",
    data: [
      { x: 348, y: 223 },
      { x: 312, y: 176 },
      { x: 277, y: 147 },
      { x: 228, y: 102 },
      { x: 471, y: 104 },
      { x: 437, y: 129 },
      { x: 405, y: 169 },
      { x: 384, y: 191 },
      { x: 363, y: 216 },
      { x: 355, y: 222 },
      { x: 349, y: 222 },
    ],
    initialValues: {
      left: "43.33%",
      top: "49.12%",
    },
  },
  {
    name: "H1_Julistepeli_6",
    data: [
      { x: 446, y: 385   },
      { x: 380, y: 427 },
      { x: 349, y: 449 },
      { x: 326, y: 465 },
      { x: 313, y: 494 },
      { x: 295, y: 505 },
      { x: 274, y: 464 },
      { x: 274, y: 436 },
      { x: 256, y: 413 },
      { x: 240, y: 393 },
      { x: 231, y: 378 },
      { x: 242, y: 373 },
      { x: 276, y: 356 },
      { x: 302, y: 338 },
      { x: 321, y: 335 },
      { x: 344, y: 316 },
      { x: 361, y: 305 },
      { x: 383, y: 288 },
      { x: 449, y: 382 },
    ],
    initialValues: {


    left: "21.83%",
    top: "-39.66%"
     },
  },
  {
    name: "H1_Julistepeli_7",
    data: [
      { x: 376, y: 275 },
      { x: 321, y: 316 },
      { x: 304, y: 329 },
      { x: 277, y: 342 },
      { x: 240, y: 365 },
      { x: 201, y: 326 },
      { x: 202, y: 100 },
      { x: 219, y: 100 },
      { x: 270, y: 154 },
      { x: 315, y: 211 },
      { x: 342, y: 235 },
      { x: 350, y: 234 },
      { x: 376, y: 273 },
    ],
    initialValues: { 
    left: "-22.8%",
    top: "57.66%"

     },
  },
  {
    name: "H1_Julistepeli_8",
    data: [
      { x: 594, y: 537 },
      { x: 574, y: 558 },
      { x: 562, y: 560 },
      { x: 529, y: 594 },
      { x: 520, y: 594 },
      { x: 516, y: 551 },
      { x: 523, y: 526 },
      { x: 521, y: 501 },
      { x: 512, y: 443 },
      { x: 507, y: 409 },
      { x: 491, y: 361 },
      { x: 521, y: 341 },
      { x: 537, y: 331 },
      { x: 542, y: 322 },
      { x: 568, y: 306 },
      { x: 583, y: 289 },
      { x: 590, y: 285 },
      { x: 596, y: 533 },
    ],
    initialValues: { 

    left: "-58.5%",
    top: "-38.66%"

    },
  },
  {
    name: "H1_Julistepeli_9",
    data: [
      { x: 359, y: 688 },
      { x: 305, y: 552 },
      { x: 285, y: 518 },
      { x: 279, y: 491 },
      { x: 266, y: 480 },
      { x: 237, y: 425 },
      { x: 222, y: 377 },
      { x: 201, y: 331 },
      { x: 201, y: 690 },
      { x: 365, y: 693 },
      { x: 357, y: 689 },
    ],
    initialValues: { 

left: "53%",
    top: "-27.83%"

     },
  },
  {
    name: "H1_Julistepeli_10",
    data: [
      { x: 598, y: 688 },
      { x: 597, y: 536 },
      { x: 404, y: 691 },
      { x: 595, y: 694 },
      { x: 596, y: 689 },
    ],

    initialValues: {

    left: "-28.33%",
    top: "14.16%"

    },
  },
];

let addedImage = data.map((e, i) => ({ ...e, img: pieceImages[e.name], stackIndex: data.length-i }));

export default addedImage;
